<template lang="pug">
section.ticket
  .ticket__left
    //- template(v-if="")
    //- if image is failed or no image show box 100x100 with icon
    picture.ticket__image
      //- img(:src="ticket.performance.image['170x240']")
      ticket-icon-big(:type="'transfers'")
      // 100x140

    .ticket__qr
      // 100x100
      qr-code-vue(:value="ticket.code" :size="80" level="H")

  .ticket__right
    .ticket__tag Трансфер
    .ticket__tag.ticket__tag-canceled(v-if="ticket.returnedAt && ticket.returnedAt.length") Отменен
    .ticket__title {{ ticket.from.name[$i18n.locale] }} - {{ ticket.to.name[$i18n.locale] }}
    .ticket__table
      .ticket__table-line Код: <span>{{ ticket.code }}</span>
      .ticket__table-line Авто: <span>{{ ticket.transfer.auto }}</span>
      .ticket__table-line Класс: <span>{{ ticket.transfer.class }}</span>
      .ticket__table-line Макс. количество пассажиров:
        <span>&nbsp;{{ ticket.transfer.max_persons }}</span>
    .ticket__price {{$t('common.total')}}: {{ ticket.price | price }} руб.
    .ticket__footer
</template>

<script>
import QrCodeVue from 'qrcode.vue';
import TicketIconBig from '../icon/big-icon';

export default {
  name: 'Transfer',
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      default: () => (null),
      required: false,
    },
    orderId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    more: [],
  }),
  mounted() {
    console.log(123);
    this.makeMore();
  },
  methods: {
    makeMore() {
    },

    doAction() {

    },

    update() {
      this.$emit('update');
    },
  },
  components: {
    QrCodeVue,
    TicketIconBig,
  },
};
</script>
